import React, { FC } from 'react';
import { Provider } from 'react-redux';
import GlobalStyle from './style/assets/styles/globalStyle';
import AppRoute from './AppRoute';
import { AppStore } from './store';
import Toast from './components/Toast';

const App: FC = () => (
	<Provider store={AppStore}>
		<AppRoute />
		<GlobalStyle />
		<Toast />
	</Provider>
);

export default App;
